import { createEdgeSpark } from "@edgespark/client";
import "@edgespark/client/styles.css";

export const client = createEdgeSpark({
  baseUrl: "https://staging--wcz2cei6tt7gvgvjgmn8.youbase.cloud"
});
